/**
 * @generated SignedSource<<2a2c4b76721d2c8216d512c19d81a692>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NodeInput = {
  id: string;
};
export type BrandAdminTabDeleteMutation$variables = {
  input: NodeInput;
};
export type BrandAdminTabDeleteMutation$data = {
  readonly deleteBrandAdmin: {
    readonly id: string;
  };
};
export type BrandAdminTabDeleteMutation = {
  response: BrandAdminTabDeleteMutation$data;
  variables: BrandAdminTabDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GraphQLBrandAdminProfile",
    "kind": "LinkedField",
    "name": "deleteBrandAdmin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BrandAdminTabDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BrandAdminTabDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "7df2f429dae43e95ce0b671d02873a01",
    "id": null,
    "metadata": {},
    "name": "BrandAdminTabDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation BrandAdminTabDeleteMutation(\n  $input: NodeInput!\n) {\n  deleteBrandAdmin(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "736ba88cad890ce4c35a5ac551d443a6";

export default node;
